var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsCleared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M7.4 32c0 3.1 2.6 5.7 5.7 5.7h15.8c3.1 0 5.7-2.6 5.7-5.7 0 0-.1-10.1-9.7-17.8h-7.2C7.2 21 7.4 31.7 7.4 31.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M24.9 14.3l3.4-7.5s-1.5-1.8-4.5-.7-2.5.8-5 0-4-.1-5.5 1.3l4.5 6.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M7.4 32c0 3.1 2.6 5.7 5.7 5.7h15.8c3.1 0 5.7-2.6 5.7-5.7 0 0-.1-10.1-9.7-17.8h-7.2C7.2 21 7.4 31.7 7.4 31.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M24.9 14.3l3.4-7.5s-1.5-1.8-4.5-.7-2.5.8-5 0-4-.1-5.5 1.3l4.5 6.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green",
    d: "M28.9 34H13.1c-1 0-1.8-1.2-1.9-1.8.2-3.7.9-5.5.9-5.5 1-4.1 6.1-9.1 7.1-9.1h3.7c1.5 0 5.8 5.9 6.7 9.1 0 0 1.2 2.3 1.1 5.6-.1.6-.8 1.7-1.8 1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsCleared);
export default __webpack_public_path__ + "static/media/cs_cleared.07049682f24bea78087316bd6014f728.svg";
export { ForwardRef as ReactComponent };